import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'

@Module({
  name: 'screen',
  stateFactory: true,
  namespaced: true,
})
export default class ScreenModule extends VuexModule {
  loading: boolean = false
  errorMessage: string = ''
  @Mutation
  public setLoading(loading: boolean) {
    this.loading = loading
  }
  @Mutation
  public setErrorMessage(message: string) {
    this.errorMessage = message
  }
}
